import { IAccountChangeStatus, IChangeResult, ISubscriptionCreateArguments } from 'fitbeat.models';
import { IMappedPlan, PaymentService } from 'fitbeat.payment-service';
import { UserProfile } from '../../entities/user/userprofile';
import { UserProfileService } from '../user';
import { IChangeFunction } from './accountstatusmanager';

export class InAppPurchaseToLiteSubscription implements IChangeFunction {
  public async validate(): Promise<IAccountChangeStatus> {
    return {
      fromStatus: 'InAppPurchase',
      toStatus: 'LiteSubscription',
      success: true,
      messageHeading: 'Cancel your in-app purchase',
      message: 'You don’t need a personal subscription anymore. Open App Store or Google Play settings ' +
        'and cancel your subscription to prevent being billed',
    };
  }

  public async change(
    userProfile: UserProfile,
    currentPlan: IMappedPlan,
    paymentService: PaymentService,
    userProfileService: UserProfileService,
    familyPlanOwnerUserProfileId?: string,
    subscriptionCreateOptions?: ISubscriptionCreateArguments,
  ): Promise<IChangeResult> {
    if (!currentPlan.subscription) {
      throw new Error(`no subscription found for current plan ${currentPlan.id}`);
    }

    if (!subscriptionCreateOptions) {
      throw new Error('subscription create arguments required');
    }

    await paymentService.cancelSubscriptionImmediately(userProfile, currentPlan.subscription.id, currentPlan.id);
    await userProfileService.updateUserSubscriptionDetails(userProfile.uid);
    const subscription = await paymentService.subscribeToPlan(subscriptionCreateOptions);
    return {
      data: subscription,
      marketingAnalyticsData: {
        trackingEventName: 'subscription_to_lite',
      },
    };
  }
}
